<template>
  <div>
    <h5 class="fs-dbb-20 mb-0">{{$t('engine.filemanager.unsplash', languageEngine)}}</h5>
    <p class="fs-sa-14 mb-0">
      {{$t('engine.filemanager.unsplash.text', languageEngine)}}
      <a href="https://unsplash.com/terms" target="_blank">
        <span class="text-primary">{{$t('engine.filemanager.unsplash.link', languageEngine)}}</span>
      </a>
    </p>

    <div
      class="d-flex justify-content-between alignitem-center mt-gd-2"
    >
      <div class="mr-gd-2" style="min-width: 300px;">
        <FormGroupHorizontal
          :label="$t('engine.filemanager.unsplash.filter', languageEngine)"
          :contentClass="'align-self-center'"
          :labelValign="'center'"
          :split="'4:8'"
        >
          <NormalSelect
            :selected="options.categoryID"
            :options="categories"
            :optionValue="'id'"
            :optionLabel="'name'"
            @change="changeFilterUnsplash"
            :block="true"
            :menuPosition="'dropright'"
          />
        </FormGroupHorizontal>
      </div>

      <div
        class="d-flex align-items-center"
        style="width: 100%; position: relative"
      >
        <span
          style="cursor: pointer; position: absolute; left: 10px"
          @click="filterUnsplash({ id: options.categoryID })"
          ><i class="far fa-search text-muted"></i
        ></span>
        <b-form-input
          class="search px-gd-4"
          v-model="options.name"
          @keyup.enter.native="filterUnsplash({ id: options.categoryID })"
          :placeholder="$t('engine.filemanager.search', languageEngine)"
        />
        <span
          v-if="options.name != ''"
          style="cursor: pointer; position: absolute; right: 10px"
          @click="
            (options.name = ''), filterUnsplash({ id: options.categoryID })
          "
        >
          <i class="fas fa-times-circle text-muted"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import fileService from "@services/fileService.js";
import FormGroupHorizontal from "@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal";
import NormalSelect from "@components_system/Shared/Tools/NormalSelect/NormalSelect";
import { mapGetters } from "vuex";
export default {
  components: {
    FormGroupHorizontal,
    NormalSelect,
  },
  data() {
    return {
      categories: [],
    };
  }, 
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    getTextFilter() {
      const filter = this.categories.filter(
        (category) => category.id === this.options.categoryID
      );
      return filter && filter[0] && filter[0].name;
    },
  },
  mounted() {
    this.getCategories();
  },
  methods: { 
    getCategories() {
      fileService.getCategoriesUnsplash().then((result) => {
        this.categories = [{ id: 0, name: this.$t('engine.filemanager.unsplash.categories', this.languageEngine)}, ...result.data];
      });
    },
    filterUnsplash({ id = 0 }) {
      this.options.p = 1;
      this.options.categoryID = id;
      this.$emit("callback", this.options);
    },
    changeFilterUnsplash(value) {
      this.options.p = 1;
      this.options.categoryID = value;
      this.$emit("callback", this.options);
    },
  },
  props: {
    limit: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Object,
      default: () => {
        return {
          p: 1,
          take: 30,
          name: "",
          categoryID: 0,
        };
      },
    },
  },
};
</script>

<style></style>
